export const REAL_ESTATE_TYPES = {
    house: 1,
    flat: 2,
    officeSpace: 3,
    land: 4,
    garage: 5,
}

export const REAL_ESTATE_SERVICE = {
    sale: 1,
    lease: 2,
}

export const ACTIVITY_TYPE = {
    SIGHTSEEING: 4,
    OFFER: 7,
}

export const SUBMIT_RESPONSE_STATUS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
}

// TODO: convert this file to .ts and mark ENTITY_TYPE/DETAIL_SEARCH_TYPE `as const` — without it, derived types like
// `(typeof DETAIL_SEARCH_TYPE)[keyof typeof DETAIL_SEARCH_TYPE]` widen to plain `string` instead of a literal union,
// so they don't actually restrict values to the 7 valid ones.
export const ENTITY_TYPE = {
    PROPERTY: 'property',
    CONTACT: 'contact',
    COMPANY: 'company',
    PROJECT: 'project',
    DOCUMENT: 'document',
    INTERMEDIARY_DIARY: 'intermediaryDiary',
    EVIDENCE_DIARY: 'evidenceDiary',
    ADMINISTRATION: 'administration',
}

export const DETAIL_SEARCH_TYPE = {
    PROPERTY: ENTITY_TYPE.PROPERTY,
    CONTACT: ENTITY_TYPE.CONTACT,
    COMPANY: ENTITY_TYPE.COMPANY,
    PROJECT: ENTITY_TYPE.PROJECT,
    DOCUMENT: ENTITY_TYPE.DOCUMENT,
    INTERMEDIARY_DIARY: ENTITY_TYPE.INTERMEDIARY_DIARY,
    EVIDENCE_DIARY: ENTITY_TYPE.EVIDENCE_DIARY,
}

export const FORM_DIRECTION = {
    ROW: 'row',
    COLUMN: 'column',
}

export const CONTACT_TYPE = {
    PERSON: 'person',
    COMPANY: 'company',
}

export const USER_SETTINGS = {
    HIDDEN_COLUMNS: 'hiddenColumns',
    COLUMN_ORDER: 'columnOrder',
    COLUMN_SORT: 'columnSort',
    PAGE_SIZE: 'pageSize',
}

export const MODAL_TYPES = {
    ACTIVITY_MODAL: 'activityModal',
    AGENT_PRINT_MODAL: 'agentPrintModal',
    CHANGE_AGENT_MODAL: 'changeAgentModal',
    CLONE_MODAL: 'cloneModal',
    DELETE_MODAL: 'deleteModal',
    EXPORT_ADS_MODAL: 'exportAdsModal',
    EXPORT_DATA_MODAL: 'exportDataModal',
    EXPORT_SYNC_MODAL: 'exportSyncModal',
    FORM_VALIDATION_ERROR_MODAL: 'formValidationErrorModal',
    NOTES_MODAL: 'notesModal',
    OFFER_BASE_MODAL: 'offerBaseModal',
    OFFER_PREVIEW_MODAL: 'offerPreviewModal',
    OFFER_SEND_MODAL: 'offerSendModal',
    OFFER_SETTINGS_MODAL: 'offerSettingsModal',
    PROPERTY_PRINT_FORM_MODAL: 'propertyPrintFormModal',
    QUICK_VIEW_MODAL: 'quickViewModal',
    READ_ALL_MODAL: 'readAllModal',
    RETURN_TO_OFFER_MODAL: 'returnToOfferModal',
    SHOPWINDOW_PRINT_MODAL: 'shopWindowPrintModal',
    TEMPLATES_MODAL: 'templatesModal',
}

export const USER_ROLES = {
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_USER: 'ROLE_USER',
}

export const PROPERTY_STATUS = {
    ACTIVE_OFFER: 1,
    RESERVED: 2,
    SOLD: 3,
    RENTED: 4,
    SOLD_OWNER_ARCHIVED: 5,
    RENTED_OWNER_ARCHIVED: 6,
    WITHDRAWN_OFFER_ARCHIVED: 7,
    SOLD_ARCHIVED: 8,
    RENTED_ARCHIVED: 9,
    FOR_AUTHORIZATION: 10,
    ANOTHER_AGENCY_AD: 11,
    SOLD_OWNER: 12,
    RENTED_OWNER: 13,
}

export const PROJECT_STATUS = {
    PREPARATION: 1,
    FOR_AUTHORIZATION: 2,
    ACTIVE: 3,
    ARCHIVED: 4,
}

export const WEBSITE_ATTRIBUTES = [
    {
        attribute: 'visibility',
        name: 'app.common.project.webSync',
    },
    {
        attribute: 'incognito',
        name: 'form.property.export.incognito',
    },
    {
        attribute: 'featuredProperty',
        name: 'form.property.export.separatedRealEstate',
    },
    {
        attribute: 'specialOffer',
        name: 'form.property.export.specialOffer',
    },
    {
        attribute: 'bestBuy',
        name: 'form.property.export.bestBuy',
    },
    {
        attribute: 'shortLease',
        name: 'form.property.export.seaProperties',
    },
]

export const CONTACT_STATUS = {
    IN_ENTRY: 1,
    HOT_LEAD: 3,
    ON_HOLD: 7,
    NO_OFFER: 13,
    NO_OFFER_OUT_OF_ZG: 14,
    ACCEPTANCE_IN_OFFER: 12,
}

export const CONTACT_PROFILE_STATUS = {
    ACTIVE_OFFER: 1,
    ACTIVE_SALES: 11,
    ACTIVE_RENTAL: 12,
}

export const INPUT_TPYES = {
    TEXT: 'text',
    NUMBER: 'number',
    DATE: 'date',
    DATETIME: 'datetime',
    TIME: 'time',
    EMAIL: 'email',
    PASSWORD: 'password',
    URL: 'url',
    CROP_DIRECTION: 'crop-direction',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    SELECT: 'select',
    TEXTAREA: 'textarea',
}

export const DOCUMENT_TYPE = {
    MEDIATION_CONTRACT: 1,
    RENTAL_CONTRACT: 3,
    OFFER: 4,
    TITLE_DEED: 5,
    LAND_REGISTRY_CERTIFICATE: 6,
    BUILDING_PERMIT: 7,
    ENERGY_EFFICIENCY_CERTIFICATE: 8,
    OTHER: 9,
    PURCHASE_CONTRACT: 10,
    PRELIMINARY_CONTRACT_OF_SALE: 11,
    ID_CARD: 12,
    USE_LICENSE: 13,
    IN_DEPTH_ANALYSIS: 14,
    GDPR: 15,
    POLITICAL_EXPOSURE_STATEMENT: 16,
    DECLARATION_OF_LEGAL_ENTITY: 17,
    HANDOVER_RECORD: 18,
    TABULAR_STATEMENT: 19,
    INVOICE: 20,
}

export const DETAIL_VIEW = {
    PROPERTY: 'property',
    CONTACT: 'contact',
    COMPANY: 'company',
    PROJECT: 'project',
}

// add more if needed
export const CONTACT_JOB_TITLE = {
    ARTISAN: 5,
    OWNER: 10,
}

// TODO: this data should come via application-settings api
export const APPLICATION_SETTINGS = {
    DEFAULT_LANGUAGE: 'hr',
    CURRENCY: '€',
    AREA_UNIT: 'm2',
}

export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{8,}$/

export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const API_URL = process.env.REACT_APP_API_URL
